import { z } from '@/lib/zod'

export function ManageEntityAccountSchema() {
  return z.object({
    entityAccount: z.boolean(),
  })
}

export type ManageEntityAccountForm = z.infer<
  ReturnType<typeof ManageEntityAccountSchema>
>
